/*
 * Product card variant swatches.
 * Shared by the homepage grids and the collection page so the card behaves
 * identically in both places.
 */
if (!customElements.get('sn-product-card')) {
  customElements.define(
    'sn-product-card',
    class SnProductCard extends HTMLElement {
      connectedCallback() {
        this.img = this.querySelector('.sn-collection__img');
        this.swatches = Array.prototype.slice.call(this.querySelectorAll('[data-swatch]'));
        if (!this.img || !this.swatches.length) return;

        // Remember the original so a swatch without an image can restore it.
        this.original = { src: this.img.src, srcset: this.img.srcset };

        this.swatches.forEach(
          function (sw) {
            sw.addEventListener('click', this.pick.bind(this, sw));
            sw.addEventListener('mouseenter', this.preload.bind(this, sw.dataset.img));
          }.bind(this)
        );
      }

      preload(url) {
        if (!url || this.seen === url) return;
        this.seen = url;
        var i = new Image();
        i.src = url;
      }

      pick(sw) {
        this.swatches.forEach(function (s) {
          s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
        });

        var url = sw.dataset.img;
        if (!url) {
          this.img.src = this.original.src;
          this.img.srcset = this.original.srcset;
          return;
        }
        // Clear srcset first, or the browser keeps serving the old candidate.
        this.img.srcset = '';
        this.img.src = url;
      }
    }
  );
}
